import React, { useEffect } from "react";
import "./BookDemoForm.css";
export type HubspotFormProps = {
  portalId: string;
  formId: string;
  region: string;
};

declare global {
  interface Window {
    hbspt: any;
  }
}

export const HubspotForm: React.FC = ( props:HubspotFormProps ) => {
  useEffect(() => {
    // Create a div for HubSpot to target
    const script = document.createElement("script");
    script.src = "//js.hsforms.net/forms/embed/v2.js";
    script.charset = "utf-8";
    script.type = "text/javascript";
    script.async = true;

    script.onload = () => {
      // form after script loads
      if (window.hbspt) {
        window.hbspt.forms.create({
          portalId: props?.portalId,
          formId: props?.formId,
          region: props?.region || "na1",
          target: "#hubspot-form-container",
          cssClass: "book-demo-form hubspot-form",
        });
      }
    };

    document.body.appendChild(script);
  }, []);

  return (
    <div className="book-demo-form">
      <div id="hubspot-form-container" className="book-form-container">        
      </div>
    </div>
  );
};
